import React from 'react';

const AppWrap = (Component, idName, classNames = '') => function HOC() {
  return (
    <section id={idName} className={`app__container ${classNames}`.trim()}>
      <div className="app__wrapper">
        <Component />
      </div>
    </section>
  );
};

export default AppWrap;
